/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component008.less';

interface IComponent008Props {
  text: string;
  img?: string;
  className?: string | null;
}

const Component008: React.FunctionComponent<IComponent008Props> = ({
  text,
  img,
  className,
}) => (
  <div className={`component008 ${className}`}>
    <div className="tip-text" dangerouslySetInnerHTML={{ __html: text }} />
    <img
      src={require(`../../../../../assets/${img}`).default}
      alt=""
      className="component008-person"
    />
  </div>
);

export default Component008;
